/**
 * Регистрирует SW, который кэширует фоны логина и регистрации.
 * Только production: в dev SW мешает hot-reload и отладке статики.
 */
export function registerLoginBgSw() {
  if (process.env.NODE_ENV !== 'production') return;
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

  const register = () => {
    navigator.serviceWorker.register('/sw-login-bg.js').catch((err) => {
      console.warn('[sw-login-bg] register failed:', err);
    });
  };

  if (document.readyState === 'complete') {
    register();
  } else {
    window.addEventListener('load', register, { once: true });
  }
}
